import React from 'react';
import { Modal, Form, Input } from 'antd';

import { DeviceCertificates, DeviceType } from '@services/types';
import { toast } from 'react-toastify';
import api from '@services/api';

const { TextArea } = Input;

interface Props {
  id: string;
  device?: DeviceType['deviceName'];
  certificateUpdate?: DeviceCertificates;
  setCertificates: (values: DeviceCertificates[]) => void;
  visible: boolean;
  onClose: VoidFunction;
}

const CertificateUpdateModal: React.FC<Props> = ({
  certificateUpdate,
  visible,
  onClose,
  id,
  device,
  setCertificates,
}) => {
  const [form] = Form.useForm<DeviceCertificates>();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (certificateUpdate) {
        await api.administration.updateDeviceTypeCertificates({
          ...values,
          deviceTypeId: id,
          id: certificateUpdate.id,
        });
        toast.success('Certificate was updated successfully');
      } else {
        await api.administration.createDeviceTypeCertificates({ ...values, deviceTypeId: id });
        toast.success('Certificate was created successfully');
      }
      const certificate = await api.administration.getDeviceTypeCertificates(id);
      setCertificates(
        certificate.map((item) => ({
          ...item,
          deviceTypeName: device,
        })),
      );
      form.resetFields();
      onClose();
    } catch (error) {
      toast.error('Certificate was not created due to error');
      console.log('Certificate ~ handleSubmit ~ error', error);
    }
  };
  return (
    <Modal
      visible={visible}
      title={certificateUpdate ? 'Modify Certificate' : 'Create Certificate'}
      okText={certificateUpdate ? 'Update' : 'Create'}
      cancelText="Cancel"
      onCancel={onClose}
      onOk={handleSubmit}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={
          certificateUpdate || {
            name: null,
            data: null,
          }
        }
      >
        <Form.Item
          name="name"
          label="Certificate Name"
          rules={[
            {
              required: true,
              message: 'Please input the Certificate Name',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="data" label="Certificate">
          <TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.memo(CertificateUpdateModal);
